import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CancellationofserviceRoutingModule } from './cancellationofservice-routing.module';
import { CancellationofserviceComponent } from './cancellationofservice.component';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { RouterModule, Routes } from '@angular/router';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time.module';

export const MY_FORMATS = {
  parseInput: 'DD/MM/YYYY',
  fullPickerInput: 'DD/MM/YYYY hh:mm a',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'hh:mm a',
  monthYearLabel: 'MMM-YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM-YYYY'
}

@NgModule({
  declarations: [CancellationofserviceComponent],
  imports: [
    CommonModule,
    NgbModule,
    CancellationofserviceRoutingModule,
    CommonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    OwlMomentDateTimeModule,
    SharedModule,
    ReactiveFormsModule,    
  ],

  providers: [
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_FORMATS }],
})
export class CancellationofserviceModule { }

